import { defaultEventDuration } from '../../constants';
import { addMilliseconds } from 'date-fns';

export const calcDefaultEndDate = (startDate: Date) => addMilliseconds(startDate, defaultEventDuration);

export const calcEndDate = (startDate: Date, endDateUTCHours: number, endDateUTCMinutes: number) => {
		const endDate = new Date(startDate);
		endDate.setUTCHours(endDateUTCHours);
		endDate.setUTCMinutes(endDateUTCMinutes);

		const isNextDay = endDateUTCHours < startDate.getUTCHours();

		if (isNextDay) {
			endDate.setDate(endDate.getDate() + 1);
		}

		return endDate;
};
